/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChevronUp = createReactComponent("chevron-up", "IconChevronUp", [
  ["path", { d: "M6 15l6 -6l6 6", key: "svg-0" }]
]);

export { IconChevronUp as default };
//# sourceMappingURL=IconChevronUp.js.map
